import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsersRouteModule } from './users-route.module';
import { UsersComponent } from './users.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import {TableModule} from 'primeng/table';
import {RadioButtonModule} from 'primeng/radiobutton';
import {ButtonModule} from 'primeng/button';
import {ToastModule} from 'primeng/toast';
import { RulesModule } from '@app/rules/rules.module';
import { ValidateRulesService } from '@app/shared/validate-rules.service';
import { MultiSelectModule } from 'primeng/multiselect';
import { SharedModule } from '../shared/shared.module';


@NgModule({
  imports: [
    CommonModule,
    UsersRouteModule,
    FormsModule,
    TableModule,
    RadioButtonModule,
    ButtonModule,
    ToastModule,
    NgbModule,
    SharedModule,
    TranslateModule,
    RulesModule,
    MultiSelectModule
  ],
  declarations: [UsersComponent],
  providers : [ValidateRulesService]
})
export class UsersModule { }
